"use client";

import { useEffect } from "react";
import { getCookie } from "@/lib/utils/common/common";

// Extend window interface for TypeScript
declare global {
  interface Window {
    __inito__?: {
      identity_manager?: {
        session_id?: string;
      };
    };
  }
}

/**
 * Hook to initialize window.__inito__.identity_manager.session_id
 * with the SessionId from cookies as soon as it's available
 */
export function useSessionInit() {
  useEffect(() => {
    const sessionId = getCookie("SessionId");
    if (!sessionId) return;

    // Don't replace an existing identity_manager — the SDK bundle assigns a
    // real IdentityManager class instance, and spreading it into a new object
    // would strip its prototype methods (renewSession, updateSession, ...).
    // Seed session_id in place; only create a placeholder if nothing is set yet.
    window.__inito__ = window.__inito__ || {};
    if (window.__inito__.identity_manager) {
      window.__inito__.identity_manager.session_id = sessionId;
    } else {
      window.__inito__.identity_manager = { session_id: sessionId };
    }
  }, []);
}

